import { useQuery } from "react-query";

import { useUser } from "@/providers/context";
import { getUserEvents } from "@/api";

interface EventsProps {
  enabled?: boolean;
}
export const useUserEvents = (props?: EventsProps) => {
  const { enabled } = props ?? {};
  const { uid } = useUser();
  return useQuery(
    ["userEvent", uid],
    () => {
      if (uid) {
        return getUserEvents({ user_id: uid });
      }
    },
    {
      enabled: enabled ?? true,
    },
  );
};
